/**
 * WHERE SETTINGS LIVES — M10 / S10-03A.
 *
 * **ONE PLACE, for the reason `report-route.ts` and `sol-capture-route.ts`
 * exist.** A path written twice is a path that can disagree with itself, and
 * Crewlink has already shipped a list that navigated nowhere because of it.
 *
 * Settings is **Project-independent**: company branding belongs to Brandon's
 * business, not to any one job, so this path carries no Project id.
 */
export const SETTINGS_PATH = '/settings';
